// src/data/comedians/robin-williams.js

const base = {
  id: 'robin-williams',
  slug: 'robin-williams',
  name: 'Robin Williams',
  birthYear: 1951,
  image: require('@/assets/images/img_Robin_Williams.png'),
  famousWorks: [
    'Mork & Mindy (1978–1982)',
    'Good Morning, Vietnam (1987)',
    'Dead Poets Society (1989)',
    'Aladdin (1992)',
    'Mrs. Doubtfire (1993)',
    'Good Will Hunting (1997)',
    'Night at the Museum series',
  ],
};

export default [
  {
    ...base,
    lang: 'en',
    nationality: 'American',
    shortBio: 'Improvisational master and beloved actor',
    bio: `Robin Williams was an American actor and comedian renowned for his improvisational skills and wide range of voices and characters. His rapid-fire comedy style and ability to seamlessly transition from comedy to drama made him one of the most beloved entertainers of his generation.\n\nBorn in Chicago, Williams studied theater at Juilliard before starting his stand-up career in San Francisco. He gained fame as the alien Mork in "Mork & Mindy" (1978–1982), which showcased his improvisational genius to the world.\n\nWilliams earned an Academy Award for "Good Will Hunting" and delivered iconic performances across film and television. His voice work as the Genie in Disney's "Aladdin" revolutionized animated film voice acting. His legacy continues to inspire comedians and actors worldwide.`,
    style: 'Rapid-fire improvisation, voices and impressions, extraordinary emotional range',
    achievements: [
      'Academy Award for Best Supporting Actor',
      'Two Emmy Awards',
      'Six Golden Globe Awards',
      'Cecil B. DeMille Award',
      'Screen Actors Guild Life Achievement Award',
    ],
  },
  {
    ...base,
    lang: 'fr',
    nationality: 'Américain',
    shortBio: 'Maître de l\'improvisation et acteur bien-aimé',
    bio: `Robin Williams était un acteur et comédien américain renommé pour ses talents d'improvisation et son répertoire inégalé de voix et de personnages. Son style comique fulgurant et sa capacité à passer de la comédie au drame en faisaient l'un des artistes les plus aimés de sa génération.\n\nNé à Chicago, Williams a étudié le théâtre à Juilliard avant de débuter dans le stand-up à San Francisco. Il a acquis la célébrité en jouant l'extraterrestre Mork dans "Mork & Mindy" (1978–1982).\n\nWilliams a remporté un Oscar pour "Good Will Hunting" et livré des performances mémorables au cinéma et à la télévision. Son interprétation du Génie dans "Aladdin" a révolutionné le doublage dans les films d'animation.`,
    style: 'Improvisation fulgurante, voix et imitations, registre émotionnel exceptionnel',
    achievements: [
      'Oscar du meilleur acteur dans un second rôle',
      'Deux Emmy Awards',
      'Six Golden Globe Awards',
      'Prix Cecil B. DeMille',
      'SAG Life Achievement Award',
    ],
  },
  {
    ...base,
    lang: 'es',
    nationality: 'Americano',
    shortBio: 'Maestro de la improvisación y actor adorado',
    bio: `Robin Williams fue un actor y comediante estadounidense reconocido por sus habilidades de improvisación y su amplio repertorio de voces y personajes. Su estilo cómico frenético y su capacidad para pasar de la comedia al drama lo convirtieron en uno de los artistas más queridos de su generación.\n\nNacido en Chicago, Williams estudió teatro en Juilliard antes de comenzar su carrera en el stand-up en San Francisco. Ganó fama como el alienígena Mork en "Mork & Mindy" (1978–1982).\n\nWilliams ganó un Oscar por "Good Will Hunting" y ofreció actuaciones icónicas en cine y televisión. Su interpretación del Genio en "Aladdin" revolucionó el doblaje en la animación.`,
    style: 'Improvisación frenética, voces e imitaciones, extraordinario rango emocional',
    achievements: [
      'Oscar al Mejor Actor de Reparto',
      'Dos Emmy Awards',
      'Seis Golden Globe Awards',
      'Premio Cecil B. DeMille',
      'SAG Life Achievement Award',
    ],
  },
  {
    ...base,
    lang: 'ar',
    nationality: 'أمريكي',
    shortBio: 'سيّد الارتجال والممثل المحبوب',
    bio: `روبن ويليامز ممثل وكوميدي أمريكي راحل اشتُهر بقدراته الارتجالية الفائقة ومخزونه الواسع من الأصوات والشخصيات. جعله أسلوبه الكوميدي المتدفق وقدرته على الانتقال السلس بين الكوميديا والدراما أحد أكثر الفنانين محبةً في جيله.\n\nوُلد في شيكاغو، ودرس المسرح في جامعة جيليار قبل أن يبدأ مسيرته في الستاند أب بسان فرانسيسكو. نال الشهرة عبر دوره كالكائن الفضائي مورك في مسلسل "Mork & Mindy" (1978–1982).\n\nفاز بجائزة الأوسكار عن فيلم "Good Will Hunting"، وقدّم أداءات أيقونية في السينما والتلفزيون. وقد أحدث تأدية دور الجني في "Aladdin" ثورة في فن دبلجة الرسوم المتحركة.`,
    style: 'ارتجال متدفق، أصوات وتقليد، مدى عاطفي استثنائي',
    achievements: [
      'جائزة الأوسكار لأفضل ممثل مساعد',
      'جائزتا Emmy',
      'ست جوائز Golden Globe',
      'جائزة سيسيل ب. ديميل',
      'جائزة SAG للإنجاز مدى الحياة',
    ],
  },
];
